import { katTranslator } from '../../shared/i18n';

export const strings = {
  'comment-prompt': {
    'en-US': 'What is your feedback?',
    'ar-AE': 'ما تقييمك؟',
    'bn-IN': 'আপনার ফিডব্যাক কী?',
    'de-DE': 'Wie lautet Ihre Bewertung?',
    'es-ES': '¿Cuál es tu valoración?',
    'es-MX': '¿Cuál es tu valoración?',
    'fr-BE': 'Quelle est votre évaluation ?',
    'fr-FR': 'Quelle est votre évaluation ?',
    'gu-IN': 'તમારો ફીડબેક શું છે?',
    'hi-IN': 'आपका फ़ीडबैक क्या है?',
    'it-IT': 'Qual è il tuo feedback?',
    'ja-JP': 'ご意見を入力してください。',
    'kn-IN': 'ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆ ಏನು?',
    'ko-KR': '귀하의 피드백은 무엇입니까?',
    'ml-IN': 'നിങ്ങളുടെ ഫീഡ്ബാക്ക് എന്താണ്?',
    'mr-IN': 'तुमचा फीडबॅक काय आहे?',
    'nl-BE': 'Wat is je feedback?',
    'nl-NL': 'Wat is je feedback?',
    'pl-PL': 'Co chcesz nam przekazać?',
    'pt-BR': 'Qual é a sua avaliação?',
    'pt-PT': 'Qual é o seu feedback?',
    'sv-SE': 'Vilken är din feedback?',
    'ta-IN': 'உங்கள் ஃபீட்பேக் என்ன?',
    'te-IN': 'మీ అభిప్రాయం ఏమిటి?',
    'th-TH': 'คุณมีความคิดเห็นว่าอย่างไร',
    'tr-TR': 'Değerlendirmeniz nedir?',
    'vi-VN': 'Hãy cho biết phản hồi của bạn?',
    'zh-CN': '您的反馈是什么？',
    'zh-TW': '您的意見回饋為何？',
  },
  'rating-prompt': {
    'en-US': 'How satisfied are you with the features on this page?',
    'ar-AE': 'ما مدى رضاك عن الخاصيات الواردة في هذه الصفحة؟',
    'bn-IN': 'এই পৃষ্ঠার ফিচারগুলিতে আপনি কতটা সন্তুষ্ট?',
    'de-DE': 'Wie zufrieden sind Sie mit den Funktionen auf dieser Seite?',
    'es-ES':
      '¿Cuál es tu grado de satisfacción con las herramientas de esta página?',
    'es-MX':
      '¿Cuál es tu nivel de satisfacción con las funciones de esta página?',
    'fr-BE':
      'Quel est votre degré de satisfaction concernant les fonctionnalités de cette page ?',
    'fr-FR':
      'Quel est votre degré de satisfaction par rapport aux fonctionnalités de cette page ?',
    'gu-IN': 'આ પેજ પરના ફીચર્સથી તમે કેટલા સંતુષ્ટ છો?',
    'hi-IN': 'आप इस पेज पर दिए गए फ़ीचर से कितने संतुष्ट हैं?',
    'it-IT':
      'Quanto sono soddisfacenti le funzioni disponibili in questa pagina?',
    'ja-JP': 'このページの機能にどの程度満足していただけましたか？',
    'kn-IN': 'ಈ ಪುಟದಲ್ಲಿನ ಫೀಚರ್‌ಗಳ ಕುರಿತು ನೀವೆಷ್ಟು ತೃಪ್ತರಾಗಿರುವಿರಿ?',
    'ko-KR': '이 페이지의 기능에 대해 어느 정도 만족하십니까?',
    'ml-IN': 'ഈ പേജിലെ ഫീച്ചറുകളിൽ നിങ്ങൾക്ക് എത്രമാത്രം സംതൃപ്‌തിയുണ്ട്?',
    'mr-IN': 'तुम्ही या पृष्ठावरील फिचर्सच्या बाबतीत किती समाधानी आहात?',
    'nl-BE': 'Hoe tevreden ben je over de functies op deze pagina?',
    'nl-NL': 'Hoe tevreden ben je over de functies op deze pagina?',
    'pl-PL':
      'Jak oceniasz swój stopień zadowolenia z funkcji dostępnych na tej stronie?',
    'pt-BR': 'Qual é o seu nível de satisfação com os recursos nesta página?',
    'pt-PT': 'Qual o seu grau de satisfação com os recursos desta página?',
    'sv-SE': 'Hur nöjd är du med funktionerna på den här sidan?',
    'ta-IN':
      'இந்தப் பக்கத்தில் உள்ள அம்சங்களில் நீங்கள் எவ்வளவு திருப்தி அடைகிறீர்கள்?',
    'te-IN': 'ఈ పేజీలోని ఫీచర్‌లతో మీరు ఎంత మేరకు సంతృప్తి చెందారు?',
    'th-TH': 'คุณพึงพอใจกับคุณสมบัติในหน้านี้มากน้อยเพียงใด',
    'tr-TR': 'Bu sayfadaki özelliklerden ne kadar memnunsunuz?',
    'vi-VN':
      'Hãy cho biết mức độ hài lòng của bạn với các tính năng trên trang này?',
    'zh-CN': '您对此页面上的功能的满意度如何？',
    'zh-TW': '您對本頁功能的滿意度為何？',
  },
  'submit-label': {
    'en-US': 'Submit',
    'ar-AE': 'إرسال',
    'bn-IN': 'জমা দিন',
    'de-DE': 'Absenden',
    'es-ES': 'Enviar',
    'es-MX': 'Enviar',
    'fr-BE': 'Soumettre',
    'fr-FR': 'Soumettre',
    'gu-IN': 'સબમિટ કરો',
    'hi-IN': 'सबमिट करें',
    'it-IT': 'Invia',
    'ja-JP': '送信',
    'kn-IN': 'ಸಬ್ಮಿಟ್ ಮಾಡಿ',
    'ko-KR': '제출',
    'ml-IN': 'സമർപ്പിക്കുക',
    'mr-IN': 'सबमिट करा',
    'nl-BE': 'Indienen',
    'nl-NL': 'Indienen',
    'pl-PL': 'Prześlij',
    'pt-BR': 'Enviar',
    'pt-PT': 'Enviar',
    'sv-SE': 'Skicka',
    'ta-IN': 'சமர்ப்பி',
    'te-IN': 'సమర్పించండి',
    'th-TH': 'ส่ง',
    'tr-TR': 'Gönder',
    'vi-VN': 'Gửi',
    'zh-CN': '提交',
    'zh-TW': '送出',
  },
  'cancel-label': {
    'en-US': 'Cancel',
    'ar-AE': 'إلغاء',
    'bn-IN': 'বাতিল করুন',
    'de-DE': 'Abbrechen',
    'es-ES': 'Cancelar',
    'es-MX': 'Cancelar',
    'fr-BE': 'Annuler',
    'fr-FR': 'Annuler',
    'gu-IN': 'કેન્સલ કરો',
    'hi-IN': 'कैंसल करें',
    'it-IT': 'Annulla',
    'ja-JP': 'キャンセル',
    'kn-IN': 'ರದ್ದು ಮಾಡಿ',
    'ko-KR': '취소',
    'ml-IN': 'റദ്ദാക്കുക',
    'mr-IN': 'कॅन्सल करा',
    'nl-BE': 'Annuleren',
    'nl-NL': 'Annuleren',
    'pl-PL': 'Anuluj',
    'pt-BR': 'Cancelar',
    'pt-PT': 'Cancelar',
    'sv-SE': 'Avbryt',
    'ta-IN': 'கேன்சல் செய்',
    'te-IN': 'రద్దు చేయండి',
    'th-TH': 'ยกเลิก',
    'tr-TR': 'İptal Et',
    'vi-VN': 'Hủy',
    'zh-CN': '取消',
    'zh-TW': '取消',
  },
  charlimit: {
    'en-US': '500 character limit',
    'ar-AE': 'الحد 500 من الأحرف',
    'bn-IN': 'অক্ষরের সীমা 500টি',
    'de-DE': 'Maximal 500 Zeichen',
    'es-ES': 'Límite de 500 caracteres',
    'es-MX': 'Límite de 500 caracteres',
    'fr-BE': 'Limite de 500 caractères',
    'fr-FR': 'Limite de caractères 500',
    'gu-IN': '500 અક્ષરની મર્યાદા',
    'hi-IN': '500 कैरेक्टर लिमिट',
    'it-IT': 'Limite di 500 caratteri',
    'ja-JP': '上限500文字',
    'kn-IN': '500 ಅಕ್ಷರಗಳ ಮಿತಿ',
    'ko-KR': '500자 제한',
    'ml-IN': '500 പ്രതീക പരിധി',
    'mr-IN': '500 वर्ण मर्यादा',
    'nl-BE': 'Limiet van 500 tekens',
    'nl-NL': 'Limiet van 500 tekens',
    'pl-PL': 'Maksymalna liczba znaków: 500',
    'pt-BR': 'Limite de 500 caracteres',
    'pt-PT': 'Limite de 500 caracteres',
    'sv-SE': 'Gräns på 500 tecken',
    'ta-IN': '500 எழுத்து வரம்பு',
    'te-IN': '500 అక్షరాల పరిమితి',
    'th-TH': 'ขีดจำกัดจำนวนอักขระ 500 ตัว',
    'tr-TR': '500 karakter sınırı',
    'vi-VN': 'Giới hạn 500 ký tự',
    'zh-CN': '限于 500 个字符',
    'zh-TW': '500 個字元限制',
  },
  disclaimer: {
    'en-US':
      'Examples of personal or sensitive data include names, addresses, telephone numbers, or email addresses. Personal or sensitive data is not necessary to complete this survey. By submitting your response, you agree you have not included this data.',
    'ar-AE':
      'تتضمن الأمثلة على البيانات الشخصية أو الحساسة الأسماء أو العناوين أو أرقام الهواتف أو عناوين البريد الإلكتروني. ليس من الضروري إدخال البيانات الشخصية أو الحساسة لإتمام هذا الاستبيان. من خلال تقديم رد من جانبك، فإنك توافق على عدم تضمينك لهذه البيانات.',
    'bn-IN':
      'ব্যক্তিগত বা সংবেদনশীল তথ্যের উদাহরণের মধ্যে নাম, ঠিকানা, টেলিফোন নম্বর বা ইমেল ঠিকানা রয়েছে। এই সমীক্ষা সম্পূর্ণ করার জন্য ব্যক্তিগত বা সংবেদনশীল তথ্য প্রয়োজনীয় নয়। আপনার উত্তর জমা দেওয়ার মাধ্যমে আপনি সম্মত হচ্ছেন যে আপনি এই তথ্য অন্তর্ভুক্ত করেননি।',
    'de-DE':
      'Beispiele für personenbezogene oder vertrauliche Daten sind Namen, Adressen, Telefonnummern und E-Mail-Adressen. Personenbezogene oder vertrauliche Daten sind für die Teilnahme an dieser Umfrage nicht erforderlich. Mit der Übermittlung Ihrer Antwort bestätigen Sie, dass Sie diese Daten nicht angegeben haben.',
    'en-AU':
      'Examples of personal or sensitive data include names, addresses, telephone numbers or email addresses. Personal or sensitive data is not necessary to complete this survey. By submitting your response, you agree that you have not included this data.',
    'en-CA':
      'Examples of personal or sensitive data include names, addresses, telephone numbers or email addresses. Personal or sensitive data is not necessary to complete this survey. By submitting your response, you agree you have not included this data.',
    'en-GB':
      'Examples of personal or sensitive data include names, addresses, telephone numbers or email addresses. Personal or sensitive data is not necessary to complete this survey. By submitting your response, you agree you have not included this data.',
    'en-IN':
      'Examples of personal or sensitive data include names, addresses, telephone numbers or e-mail addresses. Personal or sensitive data is not necessary to complete this survey. By submitting your response, you agree that you have not included this data.',
    'en-SG':
      'Examples of personal or sensitive data include names, addresses, telephone numbers or email addresses. Personal or sensitive data is not necessary to complete this survey. By submitting your response, you agree that you have not included this data.',
    'en-ZA':
      'Examples of personal or sensitive data include names, addresses, telephone numbers or email addresses. Personal or sensitive data is not necessary to complete this survey. By submitting your response, you agree that you have not included this data.',
    'es-ES':
      'Algunos ejemplos de datos personales o confidenciales son los siguientes: nombres, direcciones, números de teléfono o direcciones de correo electrónico. No es necesario proporcionar datos personales o confidenciales para completar esta encuesta. Al enviar tu respuesta, afirmas que no has incluido dichos datos.',
    'es-MX':
      'Algunos ejemplos de información personal o confidencial incluyen nombres, direcciones, números de teléfono o direcciones de correo electrónico. No se requiere información personal ni confidencial para completar esta encuesta. Al enviar tu respuesta, aceptas que no incluiste estos datos.',
    'fr-BE':
      'Les noms, adresses, numéros de téléphone ou adresses e-mail sont des exemples de données personnelles ou sensibles. Il n’est pas nécessaire de fournir des données personnelles ou sensibles pour répondre à cette enquête. En soumettant votre réponse, vous reconnaissez ne pas avoir inclus ces données.',
    'fr-FR':
      'Les noms, adresses, numéros de téléphone ou adresses e-mail sont des exemples de données personnelles ou sensibles. Il n’est pas nécessaire de fournir des données personnelles ou sensibles pour répondre à cette enquête. En soumettant votre réponse, vous reconnaissez ne pas avoir inclus ces données.',
    'gu-IN':
      'વ્યક્તિગત અથવા સંવેદનશીલ ડેટાના ઉદાહરણોમાં નામ, સરનામાં, ટેલિફોન નંબરો અથવા ઇમેઇલ એડ્રેસનો સમાવેશ થાય છે. આ સર્વેને પૂર્ણ કરવા માટે વ્યક્તિગત અથવા સંવેદનશીલ ડેટા જરૂરી નથી. તમારો પ્રતિસાદ સબમિટ કરીને, તમે સંમત થાઓ છો કે તમે આ ડેટા શામેલ કર્યો નથી.',
    'hi-IN':
      'निजी या संवेदनशील डेटा के उदाहरणों में नाम, पता, टेलीफ़ोन नंबर, या ईमेल पता शामिल हैं. इस सर्वे को पूरा करने के लिए निजी या संवेदनशील डेटा ज़रूरी नहीं है. अपना फ़ीडबैक देकर, आप सहमत हैं कि आपने यह डेटा शामिल नहीं किया है.',
    'it-IT':
      'Esempi di dati personali o sensibili sono: nomi, indirizzi, numeri di telefono o indirizzi e-mail. Non occorrono dati personali o sensibili per completare questo sondaggio. Inviando la tua risposta, confermi di non aver incluso tali dati.',
    'ja-JP':
      '個人情報または機密データには、名前、住所、電話番号、Eメールアドレスなどが含まれます。このアンケートでは、個人情報や機密データの入力は不要です。返答を送信することで、個人情報や機密データが含まれていないことに同意したものとみなされます。',
    'kn-IN':
      'ವೈಯಕ್ತಿಕ ಅಥವಾ ಸೂಕ್ಷ್ಮ ಡೇಟಾ ಎಂದರೆ ಹೆಸರುಗಳು, ವಿಳಾಸಗಳು, ಫೋನ್ ಸಂಖ್ಯೆಗಳು ಅಥವಾ ಇಮೇಲ್ ವಿಳಾಸಗಳು ಒಳಗೊಂಡಿವೆ. ಈ ಸಮೀಕ್ಷೆಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಲು ವೈಯಕ್ತಿಕ ಅಥವಾ ಸೂಕ್ಷ್ಮ ಡೇಟಾಗಳ ಅವಶ್ಯಕತೆ ಇಲ್ಲ. ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಯನ್ನು ಸಲ್ಲಿಸುವ ಮೂಲಕ, ಈ ಡೇಟಾವನ್ನು ಸೇರಿಸಿಲ್ಲ ಎಂದು ನೀವು ಒಪ್ಪುತ್ತೀರಿ.',
    'ko-KR':
      '개인 정보 또는 민감한 데이터의 예로는 이름, 주소, 전화번호나 이메일 주소가 있습니다. 이 설문 조사를 완료하는 데는 개인 정보나 민감한 데이터가 필요하지 않습니다. 응답을 제출하면, 해당 데이터를 포함하지 않았다는 데 동의하는 것으로 간주됩니다.',
    'ml-IN':
      'വ്യക്തിഗതമോ സെൻസിറ്റീവോ ആയ ഡാറ്റയുടെ ഉദാഹരണങ്ങളിൽ പേരുകളോ വിലാസങ്ങളോ ടെലിഫോൺ നമ്പറുകളോ ഇമെയിൽ വിലാസങ്ങളോ ഉൾപ്പെടുന്നു. ഈ സർവേ പൂർത്തിയാക്കാൻ വ്യക്തിഗതമോ സെൻസിറ്റീവോ ആയ ഡാറ്റ ആവശ്യമില്ല. നിങ്ങളുടെ പ്രതികരണം സമർപ്പിക്കുന്നതിലൂടെ, ഈ ഡാറ്റ ഉൾപ്പെടുത്തിയിട്ടില്ലെന്ന് നിങ്ങൾ സമ്മതിക്കുന്നു.',
    'mr-IN':
      'वैयक्तिक किंवा संवेदनशील डेटाच्या उदाहरणांमध्ये नावे, पत्ते, दूरध्वनी क्रमांक किंवा ईमेल पत्ते यांचा समावेश होतो. हे सर्वेक्षण पूर्ण करण्यासाठी वैयक्तिक किंवा संवेदनशील डेटा आवश्यक नाही. तुमचा प्रतिसाद सबमिट करून, तुमचा हा डेटा समाविष्ट केलेला नाही यास तुम्ही सहमती देता.',
    'nl-BE':
      'Voorbeelden van persoonlijke of gevoelige gegevens zijn namen, adressen, telefoonnummers of e-mailadressen. Persoonlijke of gevoelige gegevens zijn niet nodig om deze enquête in te vullen. Door je reactie in te dienen, ga je ermee akkoord dat je deze gegevens niet hebt opgenomen.',
    'nl-NL':
      'Voorbeelden van persoonlijke of gevoelige gegevens zijn namen, adressen, telefoonnummers en e-mailadressen. Persoonlijke of gevoelige gegevens zijn niet nodig om deze enquête in te vullen. Door je reactie in te dienen, verklaar je dat je geen persoonlijke of gevoelige gegevens hebt opgenomen.',
    'pl-PL':
      'Przykłady danych osobowych lub poufnych to między innymi imiona i nazwiska, adresy, numery telefonów i adresy e-mail. Wypełnienie tej ankiety nie wymaga podania danych osobowych ani poufnych. Przesyłając odpowiedź, potwierdzasz, że nie podajesz takich danych.',
    'pt-BR':
      'Exemplos de dados pessoais ou confidenciais incluem nomes, endereços, números de telefone ou endereços de e-mail. Dados pessoais ou confidenciais não são necessários para concluir esta pesquisa. Ao enviar sua resposta, você concorda que não incluiu esses dados.',
    'pt-PT':
      'Exemplos de dados pessoais ou confidenciais incluem nomes, moradas, números de telefone ou endereços de e-mail. Não são necessários dados pessoais ou confidenciais para concluir este inquérito. Ao enviar a sua resposta, confirma que não incluiu estes dados.',
    'sv-SE':
      'Exempel på personuppgifter eller känsliga uppgifter är namn, adresser, telefonnummer och e-postadresser. Personuppgifter eller känsliga uppgifter behövs inte för att slutföra enkäten. Genom att skicka in ditt svar garanterar du att du inte har inkluderat sådana uppgifter.',
    'ta-IN':
      'தனிப்பட்ட அல்லது முக்கியத் தரவின் எடுத்துக்காட்டுகளில் பெயர்கள், முகவரிகள், ஃபோன் நம்பர்கள் அல்லது இமெயில் முகவரிகள் உள்ளிட்டவை அடங்கும். இந்தப் புலத்தைப் பூர்த்தி செய்வதற்குத் தனிப்பட்ட அல்லது முக்கியத் தரவு தேவையில்லை. உங்கள் பதிலைச் சமர்ப்பிப்பதன் மூலம், நீங்கள் இந்தத் தரவைச் சேர்க்கவில்லை என ஒப்புக்கொள்கிறீர்கள்.',
    'te-IN':
      'వ్యక్తిగత లేదా సున్నితమైన డేటా, ఉదాహరణకు పేర్లు, చిరునామాలు, టెలిఫోన్ నంబర్లు లేదా ఇమెయిల్ చిరునామాలు వంటివి. ఈ సర్వేను పూర్తి చేయడానికి వ్యక్తిగత లేదా సున్నితమైన డేటా అవసరం లేదు. మీ ప్రతిస్పందనను సమర్పించడం ద్వారా, మీరు ఈ డేటాను చేర్చలేదని అంగీకరిస్తున్నారు.',
    'th-TH':
      'ตัวอย่างของข้อมูลส่วนบุคคลหรือข้อมูลที่ละเอียดอ่อน ได้แก่ ชื่อ ที่อยู่ หมายเลขโทรศัพท์ หรือที่อยู่อีเมล การตอบแบบสำรวจนี้ไม่จำเป็นต้องระบุข้อมูลส่วนบุคคลหรือข้อมูลที่ละเอียดอ่อน การส่งคำตอบจะถือว่าคุณยืนยันว่าไม่ได้ระบุข้อมูลนี้',
    'tr-TR':
      'Kişisel veya hassas verilere örnek olarak adlar, adresler, telefon numaraları ve e-posta adresleri verilebilir. Bu anketi tamamlamak için kişisel veya hassas verilere gerek yoktur. Yanıtınızı göndererek, bu verileri eklemediğinizi kabul etmiş olursunuz.',
    'vi-VN':
      'Ví dụ về dữ liệu cá nhân hoặc dữ liệu nhạy cảm bao gồm tên, địa chỉ, số điện thoại hoặc địa chỉ email. Không cần có dữ liệu cá nhân hoặc dữ liệu nhạy cảm để hoàn thành khảo sát này. Bằng cách gửi phản hồi, bạn đồng ý rằng bạn sẽ không đưa dữ liệu này vào.',
    'zh-CN':
      '个人数据或敏感数据包括姓名、地址、电话号码或电子邮件地址等。完成此调查无需提供个人数据或敏感数据。提交回复即表示您确认您未提供此类数据。',
    'zh-TW':
      '個人或機密資料的範例包括姓名、地址、電話號碼或電子郵件地址。填寫這份問卷並不需要提供任何個人或機密資料。送出回覆即表示您同意您未提供這類資料。',
  },
  'subject-prompt': {
    'en-US': 'Feedback subject',
    'ar-AE': 'موضوع التقييم',
    'bn-IN': 'ফিডব্যাকের বিষয়',
    'de-DE': 'Thema der Bewertung',
    'es-ES': 'Asunto de la valoración',
    'es-MX': 'Asunto de la valoración',
    'fr-BE': 'Sujet de l’évaluation',
    'fr-FR': 'Objet de l’évaluation',
    'gu-IN': 'ફીડબેક વિષય',
    'hi-IN': 'फ़ीडबैक का विषय',
    'it-IT': 'Argomento del feedback',
    'ja-JP': '評価の件名',
    'kn-IN': 'ಪ್ರತಿಕ್ರಿಯೆ ವಿಷಯ',
    'ko-KR': '피드백 제목',
    'ml-IN': 'ഫീഡ്ബാക്ക് വിഷയം',
    'mr-IN': 'फीडबॅकचा विषय',
    'nl-BE': 'Onderwerp van feedback',
    'nl-NL': 'Feedbackonderwerp',
    'pl-PL': 'Temat opinii',
    'pt-BR': 'Assunto da avaliação',
    'pt-PT': 'Assunto do comentário',
    'sv-SE': 'Feedbackämne',
    'ta-IN': 'ஃபீட்பேக் தலைப்பு',
    'te-IN': 'అభిప్రాయం విషయం',
    'th-TH': 'หัวเรื่องความคิดเห็น',
    'tr-TR': 'Değerlendirme konusu',
    'vi-VN': 'Tiêu đề phản hồi',
    'zh-CN': '反馈主题',
    'zh-TW': '意見回饋主題',
  },
  'subject-select': {
    'en-US': 'Select a subject',
    'ar-AE': 'تحديد موضوع',
    'bn-IN': 'একটি বিষয় নির্বাচন করুন',
    'de-DE': 'Wählen Sie ein Thema aus',
    'es-ES': 'Selecciona un asunto',
    'es-MX': 'Selecciona un asunto',
    'fr-BE': 'Sélectionner un sujet',
    'fr-FR': 'Sélectionner un sujet',
    'gu-IN': 'કોઈ એક વિષય પસંદ કરો',
    'hi-IN': 'कोई विषय चुनें',
    'it-IT': 'Seleziona un argomento',
    'ja-JP': '件名を選択',
    'kn-IN': 'ವಿಷಯವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    'ko-KR': '제목 선택',
    'ml-IN': 'ഒരു വിഷയം തിരഞ്ഞെടുക്കുക',
    'mr-IN': 'एखादा ‍विषय निवडा',
    'nl-BE': 'Selecteer een onderwerp',
    'nl-NL': 'Selecteer een onderwerp',
    'pl-PL': 'Wybierz temat',
    'pt-BR': 'Selecionar um assunto',
    'pt-PT': 'Selecione um assunto',
    'sv-SE': 'Välj ett ämne',
    'ta-IN': 'ஒரு தலைப்பைத் தேர்ந்தெடுக்கவும்',
    'te-IN': 'సబ్జెక్ట్‌ని ఎంచుకోండి',
    'th-TH': 'เลือกหัวข้อ',
    'tr-TR': 'Bir konu seçin',
    'vi-VN': 'Chọn chủ đề',
    'zh-CN': '请选择一个主题',
    'zh-TW': '選取主題',
  },
  'subject-suggestion': {
    'en-US': 'Suggestion',
    'ar-AE': 'اقتراح',
    'bn-IN': 'পরামর্শ',
    'de-DE': 'Vorschlag',
    'es-ES': 'Sugerencia',
    'es-MX': 'Sugerencia',
    'gu-IN': 'સૂચન',
    'hi-IN': 'सुझाव',
    'it-IT': 'Suggerimento',
    'ja-JP': '提案',
    'kn-IN': 'ಸಲಹೆ',
    'ko-KR': '제안 사항',
    'ml-IN': 'നിർദ്ദേശം',
    'mr-IN': 'सूचना',
    'nl-BE': 'Suggestie',
    'nl-NL': 'Suggestie',
    'pl-PL': 'Sugestia',
    'pt-BR': 'Sugestão',
    'pt-PT': 'Sugestão',
    'sv-SE': 'Förslag',
    'ta-IN': 'பரிந்துரை',
    'te-IN': 'సూచన',
    'th-TH': 'ข้อเสนอแนะ',
    'tr-TR': 'Öneri',
    'vi-VN': 'Đề xuất',
    'zh-CN': '建议',
    'zh-TW': '建議',
  },
  'subject-technical': {
    'en-US': 'Technical issue',
    'ar-AE': 'مشكلة تقنية',
    'bn-IN': 'প্রযুক্তিগত সমস্যা',
    'de-DE': 'Technisches Problem',
    'es-ES': 'Problema técnico',
    'es-MX': 'Problema técnico',
    'fr-BE': 'Problème technique',
    'fr-FR': 'Problème technique',
    'gu-IN': 'ટેકનિકલ સમસ્યા',
    'hi-IN': 'तकनीकी समस्या',
    'it-IT': 'Problema tecnico',
    'ja-JP': '技術的な問題',
    'kn-IN': 'ತಾಂತ್ರಿಕ ಸಮಸ್ಯೆ',
    'ko-KR': '기술 문제',
    'ml-IN': 'സാങ്കേതിക പ്രശ്നം',
    'mr-IN': 'तांत्रिक समस्या',
    'nl-BE': 'Technisch probleem',
    'nl-NL': 'Technisch probleem',
    'pl-PL': 'Problem techniczny',
    'pt-BR': 'Problema técnico',
    'pt-PT': 'Problema técnico',
    'sv-SE': 'Tekniskt problem',
    'ta-IN': 'தொழில்நுட்பப் பிரச்சினை',
    'te-IN': 'సాంకేతిక సమస్య',
    'th-TH': 'ปัญหาทางเทคนิค',
    'tr-TR': 'Teknik sorun',
    'vi-VN': 'Vấn đề kỹ thuật',
    'zh-CN': '技术问题',
    'zh-TW': '技術問題',
  },
  'subject-compliment': {
    'en-US': 'Compliment',
    'ar-AE': 'شكوى',
    'bn-IN': 'প্রশংসা করুন',
    'de-DE': 'Kompliment',
    'es-ES': 'Felicitación',
    'es-MX': 'Cumplido',
    'gu-IN': 'પ્રશંસા',
    'hi-IN': 'तारीफ़',
    'it-IT': 'Complimento',
    'ja-JP': '補足',
    'kn-IN': 'ಅಭಿನಂದನೆ',
    'ko-KR': '칭찬',
    'ml-IN': 'അനുമോദനം',
    'mr-IN': 'कौतुक',
    'pl-PL': 'Pochwała',
    'pt-BR': 'Elogio',
    'pt-PT': 'Elogio',
    'sv-SE': 'Komplimang',
    'ta-IN': 'பாராட்டு',
    'te-IN': 'మెచ్చుకోలు',
    'th-TH': 'ชมเชย',
    'tr-TR': 'Övgü',
    'vi-VN': 'Lời khen',
    'zh-CN': '正面',
    'zh-TW': '讚賞',
  },
  'subject-other': {
    'en-US': 'Other',
    'ar-AE': 'أخرى',
    'bn-IN': 'অন্যান্য',
    'de-DE': 'Sonstiges',
    'es-ES': 'Otro',
    'es-MX': 'Otro',
    'fr-BE': 'Autre',
    'fr-FR': 'Autre',
    'gu-IN': 'અન્ય',
    'hi-IN': 'अन्य',
    'it-IT': 'Altro',
    'ja-JP': 'その他',
    'kn-IN': 'ಇತರೆ',
    'ko-KR': '기타',
    'ml-IN': 'മറ്റുള്ളവ',
    'mr-IN': 'इतर',
    'nl-BE': 'Overige',
    'nl-NL': 'Anders',
    'pl-PL': 'Inna kwestia',
    'pt-BR': 'Outros',
    'pt-PT': 'Outros',
    'sv-SE': 'Annat',
    'ta-IN': 'மற்றவை',
    'te-IN': 'ఇతరలు',
    'th-TH': 'อื่นๆ',
    'tr-TR': 'Diğer',
    'vi-VN': 'Khác',
    'zh-CN': '其他',
    'zh-TW': '其他',
  },
  'chars-remaining': {
    'en-US': 'characters remaining',
    'ar-AE': 'الأحرف المتبقية',
    'bn-IN': 'অক্ষর বাকি আছে',
    'de-DE': 'verbleibende Zeichen',
    'es-ES': 'caracteres restantes',
    'es-MX': 'caracteres restantes',
    'fr-BE': 'caractères restants',
    'fr-FR': 'caractères restants',
    'gu-IN': 'બાકી રહેતા અક્ષરો',
    'hi-IN': 'बाकी बचे हुए कैरेक्टर',
    'it-IT': 'caratteri rimanenti',
    'ja-JP': '文字残っています',
    'kn-IN': 'ಬಾಕಿ ಉಳಿದಿರುವ ಅಕ್ಷರಗಳು',
    'ko-KR': '남은 글자 수:',
    'ml-IN': 'ശേഷിക്കുന്ന പ്രതീകങ്ങൾ',
    'mr-IN': 'शिल्लक वर्णाक्षरे',
    'nl-BE': 'resterende tekens',
    'nl-NL': 'tekens resterend',
    'pl-PL': 'to liczba znaków, które można jeszcze wpisać',
    'pt-BR': 'caracteres restantes',
    'pt-PT': 'caracteres restantes',
    'sv-SE': 'återstående tecken',
    'ta-IN': 'மீதமுள்ள எழுத்துக்குறிகள்',
    'te-IN': 'మిగిలి ఉన్న అక్షరాలు',
    'th-TH': 'จำนวนอักขระที่เหลืออยู่',
    'tr-TR': 'karakter kaldı',
    'vi-VN': 'ký tự còn lại',
    'zh-CN': '个剩余字符',
    'zh-TW': '個剩餘字元',
  },
  thanks: {
    'en-US': 'Thank you! Your feedback has been submitted.',
    'ar-AE': 'شكرًا لك! تم إرسال تقييمك.',
    'bn-IN': 'ধন্যবাদ! আপনার ফিডব্যাক জমা দেওয়া হয়েছে।',
    'de-DE': 'Vielen Dank! Ihr Feedback wurde übermittelt.',
    'es-ES': 'Gracias. Tu valoración se ha enviado correctamente.',
    'es-MX': 'Gracias. Se envió tu valoración.',
    'fr-BE': 'Merci ! Votre évaluation a été envoyée.',
    'fr-FR': 'Merci ! Votre évaluation a été envoyée.',
    'gu-IN': 'તમારો આભાર! તમારો ફીડબેક સબમિટ કરવામાં આવ્યો.',
    'hi-IN': 'धन्यवाद! आपका फ़ीडबैक सबमिट हो गया है.',
    'it-IT': 'Grazie. Il tuo feedback è stato inviato.',
    'ja-JP': 'ありがとうございました。 評価が送信されました。',
    'kn-IN': 'ಧನ್ಯವಾದಗಳು! ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಯನ್ನು ಸಲ್ಲಿಸಲಾಗಿದೆ.',
    'ko-KR': '감사합니다. 귀하의 피드백이 제출되었습니다.',
    'ml-IN': 'നന്ദി! നിങ്ങളുടെ ഫീഡ്ബാക്ക് സമർപ്പിച്ചു.',
    'mr-IN': 'धन्यवाद! तुमचा फीडबॅक सबमिट केला आहे.',
    'nl-BE': 'Hartelijk dank! Je feedback is ingediend.',
    'nl-NL': 'Hartelijk dank! Je feedback is ingediend.',
    'pl-PL': 'Dziękujemy! Twoja opinia została przesłana.',
    'pt-BR': 'Obrigado. Sua avaliação foi enviada.',
    'pt-PT': 'Obrigado! O seu comentário foi enviado.',
    'sv-SE': 'Tack! Din feedback har skickats in.',
    'ta-IN': 'நன்றி! உங்கள் ஃபீட்பேக் சமர்ப்பிக்கப்பட்டுள்ளது.',
    'te-IN': 'ధన్యవాదాలు! మీ ఫీడ్‌బ్యాక్ సమర్పించబడింది.',
    'th-TH': 'ขอบคุณ! ส่งความคิดเห็นของคุณเรียบร้อยแล้ว',
    'tr-TR': 'Teşekkürler! Değerlendirmeniz gönderildi.',
    'vi-VN': 'Cảm ơn bạn! Phản hồi của bạn đã được gửi đi.',
    'zh-CN': '谢谢！ 您的反馈已提交。',
    'zh-TW': '謝謝您！ 已送出您的意見回饋。',
  },
  'popup-prompt': {
    'en-US': 'What is personal or sensitive data?',
    'ar-AE': 'ما المقصود بالبيانات الشخصية أو الحساسة؟',
    'bn-IN': 'ব্যক্তিগত বা সংবেদনশীল তথ্য কী?',
    'de-DE': 'Was sind persönliche oder vertrauliche Daten?',
    'es-ES': '¿Qué son los datos personales o confidenciales?',
    'es-MX': '¿Qué es la información personal o confidencial?',
    'fr-BE': 'Qu’est-ce que des données personnelles ou sensibles ?',
    'fr-FR': 'Que sont des données personnelles ou sensibles ?',
    'gu-IN': 'વ્યક્તિગત અથવા સંવેદનશીલ ડેટા શું છે?',
    'hi-IN': 'निजी या संवेदनशील डेटा क्या है?',
    'it-IT': 'Che cosa sono i dati personali o sensibili?',
    'ja-JP': '個人情報または機密データとは何ですか？',
    'kn-IN': 'ವೈಯಕ್ತಿಕ ಅಥವಾ ಸೂಕ್ಷ್ಮ ಡೇಟಾ ಎಂದರೇನು?',
    'ko-KR': '개인 데이터 또는 민감한 데이터란 무엇입니까?',
    'ml-IN': 'വ്യക്തിപരമോ സെൻസിറ്റീവോ ആയ ഡാറ്റ എന്നാൽ എന്താണ്?',
    'mr-IN': 'वैयक्तिक किंवा संवेदनशील डेटा काय आहे?',
    'nl-BE': 'Wat zijn persoonlijke of gevoelige gegevens?',
    'nl-NL': 'Wat zijn persoonlijke of gevoelige gegevens?',
    'pl-PL': 'Czym są dane osobowe lub poufne?',
    'pt-BR': 'O que são dados pessoais ou confidenciais?',
    'pt-PT': 'O que são dados pessoais ou confidenciais?',
    'sv-SE': 'Vad är personuppgifter eller känsliga uppgifter?',
    'ta-IN': 'தனிப்பட்ட அல்லது முக்கியமான தரவு என்றால் என்ன?',
    'te-IN': 'వ్యక్తిగత లేదా సున్నితమైన డేటా అంటే ఏమిటి?',
    'th-TH': 'ข้อมูลส่วนบุคคลหรือข้อมูลที่ละเอียดอ่อนคืออะไร',
    'tr-TR': 'Kişisel veya hassas veri nedir?',
    'vi-VN': 'Thế nào là dữ liệu cá nhân hoặc dữ liệu nhạy cảm?',
    'zh-CN': '什么是个人数据或敏感数据？',
    'zh-TW': '個人或機密資料為何？',
  },
  'textarea-placeholder': {
    'en-US': 'Do not include personal or sensitive data in your feedback.',
    'ar-AE': 'لا تقم بتضمين بيانات شخصية أو حساسة في تقييمك.',
    'bn-IN':
      'আপনার প্রতিক্রিয়ায় ব্যক্তিগত বা সংবেদনশীল তথ্য অন্তর্ভুক্ত করবেন না।',
    'de-DE':
      'Geben Sie im Feedback keine personenbezogenen oder vertraulichen Daten an.',
    'es-ES': 'No incluyas datos personales ni confidenciales en la valoración.',
    'es-MX':
      'No incluyas información personal ni confidencial en tus valoraciones.',
    'fr-BE':
      'N’incluez pas de données personnelles ou sensibles dans vos commentaires.',
    'fr-FR':
      'N’incluez pas de données personnelles ou sensibles dans votre évaluation.',
    'gu-IN': 'તમારા ફીડબેકમાં વ્યક્તિગત અથવા સંવેદનશીલ ડેટા શામેલ કરશો નહીં.',
    'hi-IN': 'अपने फ़ीडबैक में निजी या संवेदनशील डेटा न डालें.',
    'it-IT': 'Non includere dati personali o sensibili nel feedback.',
    'ja-JP': '個人情報または機密データは評価に含めないでください。',
    'kn-IN':
      'ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಯಲ್ಲಿ ವೈಯಕ್ತಿಕ ಅಥವಾ ಸೂಕ್ಷ್ಮ ಡೇಟಾವನ್ನು ಸೇರಿಸಬೇಡಿ.',
    'ko-KR': '피드백에 개인 정보나 민감한 데이터를 포함해서는 안 됩니다.',
    'ml-IN':
      'നിങ്ങളുടെ ഫീഡ്ബാക്കിൽ വ്യക്തിപരമോ സെൻസിറ്റീവോ ആയ ഡാറ്റ ഉൾപ്പെടുത്തരുത്.',
    'mr-IN':
      'तुमच्या अभिप्रायामध्ये वैयक्तिक किंवा संवेदनशील माहिती समाविष्ट करू नका.',
    'nl-BE': 'Vermeld geen persoonlijke of gevoelige gegevens in je feedback.',
    'nl-NL': 'Neem geen persoonlijke of gevoelige gegevens op in je feedback.',
    'pl-PL': 'Nie umieszczaj w opinii żadnych danych osobowych ani poufnych.',
    'pt-BR': 'Não inclua dados pessoais ou confidenciais em sua avaliação.',
    'pt-PT': 'Não inclua dados pessoais ou confidenciais nos seus comentários.',
    'sv-SE':
      'Inkludera inte personuppgifter eller känsliga uppgifter i din feedback.',
    'ta-IN':
      'உங்கள் ஃபீட்பேக்குளில் தனிப்பட்ட அல்லது முக்கியத் தரவைச் சேர்க்க வேண்டாம்.',
    'te-IN': 'మీ అభిప్రాయం‌లో వ్యక్తిగత లేదా సున్నితమైన డేటాను చేర్చవద్దు.',
    'th-TH':
      'อย่าใส่ข้อมูลส่วนบุคคลหรือข้อมูลที่ละเอียดอ่อนลงในความคิดเห็นของคุณ',
    'tr-TR': 'Değerlendirmeniz kişisel veya hassas veri eklemeyin.',
    'vi-VN':
      'Không cung cấp dữ liệu cá nhân hoặc dữ liệu nhạy cảm trong phản hồi của bạn.',
    'zh-CN': '请勿在您的反馈中包含个人数据或敏感数据。',
    'zh-TW': '請勿在您的意見回饋中提供個人或機密資料。',
  },
  'modal-title': {
    'en-US': 'Rate This Page',
    'ar-AE': 'تقييم هذه الصفحة',
    'bn-IN': 'এই পেজে রেট দিন',
    'de-DE': 'Diese Seite bewerten',
    'en-AU': 'Rate this page',
    'en-CA': 'Rate this page',
    'en-GB': 'Rate this page',
    'en-SG': 'Rate this page',
    'en-ZA': 'Rate this page',
    'es-ES': 'Evaluar esta página',
    'es-MX': 'Calificar esta página',
    'fr-BE': 'Évaluer cette page',
    'fr-FR': 'Évaluer cette page',
    'gu-IN': 'આ પેજને રેટ કરો',
    'hi-IN': 'इस पेज को रेटिंग दें',
    'it-IT': 'Valuta questa pagina',
    'ja-JP': 'このページを評価する',
    'kn-IN': 'ಈ ಪೇಜ್‌ಗೆ ರೇಟ್ ನೀಡಿ',
    'ko-KR': '이 페이지 평가',
    'ml-IN': 'ഈ പേജ് റേറ്റ് ചെയ്യുക',
    'mr-IN': 'या पृष्ठाला रेट करा',
    'nl-BE': 'Deze pagina beoordelen',
    'nl-NL': 'Deze pagina beoordelen',
    'pl-PL': 'Oceń tę stronę',
    'pt-BR': 'Avaliar esta página',
    'pt-PT': 'Classificar esta página',
    'sv-SE': 'Betygsätt den här sidan',
    'ta-IN': 'இந்தப் பக்கத்தை மதிப்பீடு செய்யவும்',
    'te-IN': 'ఈ పేజీకి రేటింగ్ ఇవ్వండి',
    'th-TH': 'ให้คะแนนหน้านี้',
    'tr-TR': 'Bu Sayfayı Değerlendir',
    'vi-VN': 'Đánh giá trang này',
    'zh-CN': '为此页评分',
    'zh-TW': '為這個頁面評分',
  },
  'very-unsatisfied-option': {
    'en-US': 'Very unsatisfied',
    'ar-AE': 'غير راضٍ للغاية',
    'bn-IN': 'খুবই অসন্তুষ্ট',
    'de-DE': 'Sehr unzufrieden',
    'es-ES': 'Muy bajo',
    'es-MX': 'Muy insatisfecho',
    'fr-BE': 'Très insatisfait(e)',
    'fr-FR': 'Très insatisfait(e)',
    'gu-IN': 'ખૂબ જ અસંતુષ્ટ',
    'hi-IN': 'बहुत असंतुष्ट',
    'it-IT': 'Molto insoddisfacente',
    'ja-JP': '非常に不満',
    'kn-IN': 'ಬಹಳ ಅತೃಪ್ತಿಕರ',
    'ko-KR': '매우 불만족함',
    'ml-IN': 'വളരെ അസംതൃപ്‌തി',
    'mr-IN': 'खूप असमाधानी',
    'nl-BE': 'Zeer ontevreden',
    'nl-NL': 'Zeer ontevreden',
    'pl-PL': 'Jestem bardzo niezadowolony(-na)',
    'pt-BR': 'Muito insatisfeito',
    'pt-PT': 'Muito insatisfeito',
    'sv-SE': 'Mycket missnöjd',
    'ta-IN': 'மிக அதிருப்தி',
    'te-IN': 'చాలా సంతృప్తి చెందలేదు',
    'th-TH': 'ไม่พอใจอย่างยิ่ง',
    'tr-TR': 'Hiç memnun değilim',
    'vi-VN': 'Rất không hài lòng',
    'zh-CN': '非常不满意',
    'zh-TW': '非常不滿意',
  },
  'unsatisfied-option': {
    'en-US': 'Unsatisfied',
    'ar-AE': 'غير راضٍ',
    'bn-IN': 'অসন্তুষ্ট',
    'de-DE': 'Unzufrieden',
    'es-ES': 'Bajo',
    'es-MX': 'Insatisfecho',
    'fr-BE': 'insatisfait(e)',
    'fr-FR': 'Insatisfait(e)',
    'gu-IN': 'અસંતુષ્ટ',
    'hi-IN': 'असंतुष्ट',
    'it-IT': 'Insoddisfacente',
    'ja-JP': '不満',
    'kn-IN': 'ಅತೃಪ್ತಿ',
    'ko-KR': '불만족함',
    'ml-IN': 'അസംതൃപ്‌തിയുണ്ട്',
    'mr-IN': 'असमाधानी',
    'nl-BE': 'Ontevreden',
    'nl-NL': 'Ontevreden',
    'pl-PL': 'Jestem niezadowolony(-na)',
    'pt-BR': 'Insatisfeito',
    'pt-PT': 'Insatisfeito',
    'sv-SE': 'Missnöjd',
    'ta-IN': 'அதிருப்தி',
    'te-IN': 'సంతృప్తి చెందలేదు',
    'th-TH': 'ไม่พอใจ',
    'tr-TR': 'Memnun değilim',
    'vi-VN': 'Không hài lòng',
    'zh-CN': '不满意',
    'zh-TW': '不滿意',
  },
  'neutral-option': {
    'en-US': 'Neutral',
    'ar-AE': 'محايد',
    'bn-IN': 'নিরপেক্ষ',
    'fr-BE': 'Neutre',
    'fr-FR': 'Neutre',
    'gu-IN': 'તટસ્થ',
    'hi-IN': 'न तो संतुष्ट न ही असंतुष्ट',
    'it-IT': 'Neutrale',
    'ja-JP': 'どちらでもない',
    'kn-IN': 'ತಟಸ್ಥ',
    'ko-KR': '중립적',
    'ml-IN': 'വിയോജിക്കുകയോ യോജിക്കുകയോ ചെയ്യുന്നില്ല',
    'mr-IN': 'तटस्थ',
    'nl-BE': 'Neutraal',
    'nl-NL': 'Neutraal',
    'pl-PL': 'Nie jestem ani zadowolony(-na), ani niezadowolony(-na)',
    'pt-BR': 'Neutro',
    'pt-PT': 'Neutro',
    'ta-IN': 'நடுநிலை',
    'te-IN': 'తటస్థమైనది',
    'th-TH': 'เฉยๆ',
    'tr-TR': 'Nötr',
    'vi-VN': 'Bình thường',
    'zh-CN': '中立',
    'zh-TW': '沒意見',
  },
  'satisfied-option': {
    'en-US': 'Satisfied',
    'ar-AE': 'راضٍ',
    'bn-IN': 'সন্তুষ্ট',
    'de-DE': 'Zufrieden',
    'es-ES': 'Alto',
    'es-MX': 'Satisfecho',
    'fr-BE': 'Satisfait(e)',
    'fr-FR': 'Satisfait(e)',
    'gu-IN': 'સંતુષ્ટ',
    'hi-IN': 'संतुष्ट',
    'it-IT': 'Soddisfacente',
    'ja-JP': '満足',
    'kn-IN': 'ತೃಪ್ತಿಕರ',
    'ko-KR': '만족함',
    'ml-IN': 'സംതൃപ്‌തിയുണ്ട്',
    'mr-IN': 'समाधानी',
    'nl-BE': 'Tevreden',
    'nl-NL': 'Tevreden',
    'pl-PL': 'Jestem zadowolony(-na)',
    'pt-BR': 'Satisfeito',
    'pt-PT': 'Satisfeito',
    'sv-SE': 'Nöjd',
    'ta-IN': 'திருப்தி',
    'te-IN': 'సంతృప్తి చెందాను',
    'th-TH': 'พอใจ',
    'tr-TR': 'Memnunum',
    'vi-VN': 'Hài lòng',
    'zh-CN': '满意',
    'zh-TW': '滿意',
  },
  'very-satisfied-option': {
    'en-US': 'Very satisfied',
    'ar-AE': 'راضٍ للغاية',
    'bn-IN': 'অত্যন্ত সন্তুষ্ট',
    'de-DE': 'Sehr zufrieden',
    'es-ES': 'Muy alto',
    'es-MX': 'Muy satisfecho',
    'fr-BE': 'Très satisfait(e)',
    'fr-FR': 'Très satisfait(e)',
    'gu-IN': 'ખૂબ જ સંતુષ્ટ',
    'hi-IN': 'बहुत संतुष्ट',
    'it-IT': 'Molto soddisfacente',
    'ja-JP': '非常に満足',
    'kn-IN': 'ಬಹಳ ತೃಪ್ತಿಕರ',
    'ko-KR': '매우 만족함',
    'ml-IN': 'വളരെ തൃപ്തിയായി',
    'mr-IN': 'खूप समाधानी',
    'nl-BE': 'Zeer tevreden',
    'nl-NL': 'Zeer tevreden',
    'pl-PL': 'Jestem bardzo zadowolony(-na)',
    'pt-BR': 'Muito satisfeito',
    'pt-PT': 'Muito satisfeito',
    'sv-SE': 'Mycket nöjd',
    'ta-IN': 'மிகவும் திருப்தி',
    'te-IN': 'చాలా సంతృప్తి చెందాను',
    'th-TH': 'พอใจอย่างยิ่ง',
    'tr-TR': 'Çok memnunum',
    'vi-VN': 'Rất hài lòng',
    'zh-CN': '非常满意',
    'zh-TW': '非常滿意',
  },
};

export default katTranslator(strings);
